import { useEffect } from "react";
import SmoothScroll from "@/lib/SmoothScroll";
import Footer from "@/components/site/Footer";
import AdvisoryNav from "@/components/advisory/AdvisoryNav";
import AdvisoryHero from "@/components/advisory/AdvisoryHero";
import AuditBanner from "@/components/advisory/AuditBanner";
import AdvisoryCards from "@/components/advisory/AdvisoryCards";
import Transformation from "@/components/advisory/Transformation";
import AuditFlow from "@/components/advisory/AuditFlow";
import { trackEvent } from "@/lib/track";

export default function AdvisoryPage() {
  useEffect(() => {
    trackEvent("view", "advisory");
  }, []);

  return (
    <SmoothScroll>
      <div className="relative bg-background">
        <AdvisoryNav />
        <main>
          <AdvisoryHero />
          <AuditBanner />
          <AdvisoryCards />
          <Transformation />
          <AuditFlow />
        </main>
        <Footer basePath="/" />
      </div>
    </SmoothScroll>
  );
}
